var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"login-box-mount-point"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }